import React, { useState, useEffect } from "react";

function GuestDetailsModal({ open, onSubmit, onJoinWithToken }) {
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [count, setCount] = useState("");
  const [error, setError] = useState("");

  const [showTokenModal, setShowTokenModal] = useState(false);
  const [token, setToken] = useState("");

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (open || showTokenModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [open, showTokenModal]);

  if (!open && !showTokenModal) return null;

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      setMobile(value);
      setError("");
    }
  };

  const handleCountChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value === "") {
      setCount("");
      setError("");
      return;
    }

    const num = Number(value);
    if (num >= 1 && num <= 15) {
      setCount(num);
      setError("");
    }
  };

  const handleSubmit = async () => {
    if (!name.trim()) {
      setError("Please enter your name");
      return;
    }

    if (!mobile || !mobile.trim()) {
      setError("Please enter your mobile number");
      return;
    }

    if (mobile.length !== 10) {
      setError("Please enter a valid mobile number");
      return;
    }

    if (count === "" || count === null || count === undefined) {
      setError("Please enter guest count");
      return;
    }

    if (count < 1 || count > 15) {
      setError("Please enter a valid guest count");
      return;
    }

    setError("");

    const backendError = await onSubmit({
      name: name.trim(),
      mobile: mobile.trim(),
      count,
    });

    if (backendError) {
      setError(backendError);
    }
  };


  const handleJoinSubmit = async () => {
    if (!token.trim()) {
      setError("Please enter a valid token");
      return;
    }

    setError("");

    const backendError = await onJoinWithToken(token.trim());

    if (backendError) {
      setError(backendError);
      return;
    }

    setShowTokenModal(false);
    setToken("");
  };

  return (
    <>
      {/* MAIN MODAL */}

      {!showTokenModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8">
            {/* Icon */}
            <div className="flex flex-col items-center mb-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-full mb-4">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-800">Welcome</h2>
              <p className="text-gray-500 mt-2">
                Join the table and start ordering
              </p>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2 text-start">
                  Name <span className="text-red-500">*</span>
                </label>
                <input
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition-all"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setError("");
                  }}
                  required
                  autoComplete="name"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2 text-start">
                  Mobile Number <span className="text-red-500">*</span>
                </label>

                <input
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition-all"
                  placeholder="Enter mobile number"
                  value={mobile}
                  onChange={handleMobileChange}
                  maxLength={10}
                  required
                  inputMode="numeric"
                  autoComplete="tel"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2 text-start">
                  Guest Count <span className="text-red-500">*</span>
                </label>
                <input
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition-all"
                  type="number"
                  placeholder="Enter guest count"
                  value={count}
                  min={1}
                  max={15}
                  onChange={handleCountChange}
                  required
                  inputMode="numeric"
                />
              </div>

              {error && (
                <div className="text-red-600 text-sm text-center">{error}</div>
              )}

              <button
                className="w-full py-3 bg-gradient-to-r from-orange-500 to-red-500 text-white font-semibold rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                onClick={handleSubmit}
              >
                Continue
              </button>

              {/* TOKEN CTA */}
              <div className="text-center mt-4">
                <span className="text-sm text-gray-600">
                  Already have a group token?{" "}
                </span>
                <button
                  className="text-orange-500 font-medium text-sm hover:text-orange-600 transition-colors"
                  onClick={() => {
                    setError("");
                    setShowTokenModal(true);
                  }}
                >
                  Enter Token
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* TOKEN MODAL */}
      {showTokenModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8">
            {/* Icon */}
            <div className="flex flex-col items-center mb-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-full mb-4">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-800">
                Join Group Order
              </h2>
              <p className="text-gray-500 mt-2">Enter your 6-digit token</p>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2 text-start">
                  Token
                </label>
                <input
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition-all text-center text-xl font-semibold tracking-widest"
                  placeholder="000000"
                  value={token}
                  maxLength={6}
                  inputMode="numeric"
                  onChange={(e) => setToken(e.target.value.replace(/\D/g, ""))}
                />
              </div>

              {error && (
                <div className="text-red-600 text-sm text-center">{error}</div>
              )}

              <button
                className="w-full py-3 bg-gradient-to-r from-orange-500 to-red-500 text-white font-semibold rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                onClick={handleJoinSubmit}
              >
                Join
              </button>

              <button
                className="w-full py-3 border border-gray-300 text-gray-700 font-semibold rounded-lg hover:bg-gray-50 transition-all"
                onClick={() => {
                  setShowTokenModal(false);
                  setError("");
                  setToken("");
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default GuestDetailsModal;
